var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8179 12.8177L17.8501 7.78545C18.9431 6.69247 18.9431 4.92041 17.8501 3.82743C16.7571 2.73446 14.9851 2.73446 13.8921 3.82743L8.85984 8.85968C7.76686 9.95266 7.76686 11.7247 8.85984 12.8177C9.95281 13.9107 11.7249 13.9107 12.8179 12.8177ZM18.7743 2.90322C17.1709 1.29982 14.5713 1.29981 12.9679 2.90322L7.93562 7.93547C6.33222 9.53887 6.33222 12.1385 7.93562 13.7419C9.53903 15.3453 12.1387 15.3453 13.7421 13.7419L18.7743 8.70966C20.3777 7.10626 20.3777 4.50662 18.7743 2.90322Z",
    fill: "#12929E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3 (Stroke)",
    d: "M14.7871 14.7869L9.75482 19.8191C8.85711 20.7168 7.40163 20.7168 6.50392 19.8191C5.6062 18.9214 5.6062 17.4659 6.50392 16.5682L11.5362 11.536C12.4339 10.6383 13.8894 10.6383 14.7871 11.536C15.6848 12.4337 15.6848 13.8892 14.7871 14.7869ZM16.4184 9.90465C14.6197 8.10598 11.7035 8.10598 9.90485 9.90465L4.8726 14.9369C3.07393 16.7356 3.07393 19.6518 4.8726 21.4504C6.67126 23.2491 9.58748 23.2491 11.3861 21.4504L16.4184 16.4182C18.2171 14.6195 18.2171 11.7033 16.4184 9.90465Z",
    fill: "#12929E",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4 (Stroke) (Stroke)",
    d: "M8.97379 10.7961C8.96269 11.2874 9.14463 11.7823 9.5196 12.1573C9.78149 12.4192 10.1019 12.5869 10.4387 12.6605L10.2113 13.5664L9.89302 14.8345L9.66567 15.7402C8.78962 15.5315 7.9586 15.0853 7.27509 14.4018C6.54491 13.6716 6.08565 12.7731 5.8973 11.8312L6.79109 11.5305L7.88244 11.1633L8.97379 10.7961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4 (Stroke)_2",
    d: "M8.85976 8.85976C7.76678 9.95273 7.76678 11.7248 8.85976 12.8178C9.95274 13.9108 11.7248 13.9108 12.8178 12.8178L13.742 13.742C12.1386 15.3454 9.53895 15.3454 7.93555 13.742C6.33214 12.1386 6.33214 9.53895 7.93555 7.93555L8.85976 8.85976Z",
    fill: "#12929E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.9e5415a1.svg";
export { ForwardRef as ReactComponent };